module.exports = __webpack_public_path__ + "img/tee.f288d228.png";